"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var message = function (_a) {
    var content = _a.content, type = _a.type, duration = _a.duration, className = _a.className, key = _a.key, onClick = _a.onClick, onClose = _a.onClose;
    antd_1.message[type]({
        className: className,
        duration: duration,
        content: content,
        key: key,
        onClick: onClick,
        onClose: onClose,
    });
    return function () { return key != null && antd_1.message.destroy(key); };
};
exports.default = message;
